import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AuthState {
  isAdmin: boolean;
  adminToken: string | null;
  login: (token: string) => void;
  logout: () => void;
  checkAdmin: () => boolean;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      isAdmin: false,
      adminToken: null,
      login: (token: string) => set({ isAdmin: true, adminToken: token }),
      logout: () => set({ isAdmin: false, adminToken: null }),
      checkAdmin: () => get().isAdmin,
    }),
    {
      name: 'ffidunban-auth',
      partialize: (state) => ({ isAdmin: state.isAdmin, adminToken: state.adminToken }),
    }
  )
);